import makeStyles from '@material-ui/core/styles/makeStyles';

const styles = makeStyles(() => ({
  tabs: {
    borderBottom: '1px solid #d8d8d8',
  },

  tab: {
    minWidth: 110,
  },
}));

export default styles;
